
import CreateBooking from "@/components/bookings/CreateBooking.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    CreateBooking,
  },
})
export default class CreateBookingView extends Vue {
  //
}
